import React from 'react';

const PolygonAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg style={{ width: '100%', display: 'block' }} viewBox="0 0 87 87" {...props}>
    <g fillRule="nonzero" fill="none">
      <rect fill={props.color || '#FF7600'} x={0.23} y={0.4} width={86.6} height={86.6} rx={43.3} />
      <g fill="#FFF">
        <path opacity={0.5} d="M67 57.5L43.5 71 20 57.5v-27L43.5 17 67 30.5z" />
        <path opacity={0.5} d="M67 50.75L49.5 61 32 50.75v-20.5L49.5 20 67 30.25z" />
        <path opacity={0.5} d="M67 43.248L55.5 50 44 43.248V29.752L55.5 23 67 29.752z" />
        <path opacity={0.9} d="M67 37.503L61 41l-6-3.497v-7.006L61 27l6 3.497z" />
      </g>
    </g>
  </svg>
);

export default PolygonAnnotationIcon;
